import { Box } from '@mui/material';
import { SCRIVE_TYPE } from '@treyd-io/core/constants/auth';
import { useState } from 'react';
import { BankIdConnectionBody } from './BankIdConnectionBody';
import { BankIdDialogBody } from './BankIdDialogBody';

interface Props {
  onSignWithVerificationCodeClick: () => void;
  cancelSignCallback: () => void;
  signCallback: () => void;
  isPollingData: boolean;
  scriveUrl?: string;
  error?: string;
  type: SCRIVE_TYPE;
}

type Step = 'initial' | 'bankIdConnection';

export const BankIdDialog = (props: Props) => {
  const {
    onSignWithVerificationCodeClick,
    cancelSignCallback,
    isPollingData,
    signCallback,
    scriveUrl,
    error,
    type,
  } = props;
  const [activeStep, setActiveStep] = useState<Step>('initial');

  const handlePersonalNumberSubmit = () => {
    setActiveStep('bankIdConnection');
  };

  const STEPS: Record<Step, React.ReactNode> = {
    initial: (
      <BankIdDialogBody
        onSubmit={handlePersonalNumberSubmit}
        onSignWithVerificationCodeClick={onSignWithVerificationCodeClick}
        type={type}
      />
    ),
    bankIdConnection: (
      <BankIdConnectionBody
        cancelSignCallback={cancelSignCallback}
        signCallback={signCallback}
        isPollingData={isPollingData}
        scriveUrl={scriveUrl}
        error={error}
      />
    ),
  };

  return <Box>{STEPS[activeStep]}</Box>;
};
